import React, { Component } from 'react';
import { params } from '../config';
export default class PredictiveStreetSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			placeholder: props.placeholder ?? 'Ejemplo: Apoquindo 5550, Las condes',
			searchTerm: props.searchTerm,
			data: {
				firstAddress: "",
				lastAddress: "",
				city: "",
				latitud: "",
				longitud: "",
			}
		};
	}
	componentDidMount() {
		const apikey = params.google_place_key;
		const script = document.createElement('script');
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apikey}&libraries=places&callback=initAutocomplete`;
		script.async = true;
		script.defer = true;
		script.setAttribute('id', 'scriptGoogleLocation');
		document.body.appendChild(script);
		
		window.initAutocomplete = () => {
			const input = document.getElementById('inputPredictiveStreetSearch');
  
			const autocomplete = new window.google.maps.places.Autocomplete(input,{
				componentRestrictions: { country: 'CL' },
				fields: ["geometry", "address_components"]
			});
	  
			autocomplete.addListener('place_changed', () => {
  				const { geometry, address_components = [] } = autocomplete.getPlace();
  				if (!geometry) return;

  				const cityComuna = address_components.find(c => c.types.includes("locality"))?.long_name || "";
  				const route = address_components.find(c => c.types.includes("route"))?.long_name || "";
  				const streetNumber = address_components.find(c => c.types.includes("street_number"))?.long_name || "";
  				const reference = address_components.find(c => c.types.includes("subpremise"))?.long_name || "";
  				const lastAddress = `${route} ${streetNumber}`;

				const data = {
					firstAddress: cityComuna,
					lastAddress,
					city: cityComuna,
					latitud: `${geometry.location.lat()}`,
					longitud: `${geometry.location.lng()}`,
					reference
				};

			  	this.setState({ data }, ()=> {
					if(this.props.changeValue) this.props.changeValue(data);
					if(this.props.getDataOnPalceChanged) this.props.getDataOnPalceChanged({...data, formatedValue: input.value.trim()});
				});
			});
		};
	}
	componentWillUnmount() {
		const script = document.getElementById('scriptGoogleLocation');
		if (script) script.remove();
	}
	render() {
		const {placeholder, searchTerm} = this.state;
		
		return (<>
			<input
				id='inputPredictiveStreetSearch'
				placeholder={placeholder}
				value={searchTerm}
			/>
		</>);
	}
}
